export const notificationItemStyle = {
	wrapper: {
		display: 'flex',
		alignItems: 'start',
		padding: '6px 12px 6px 6px',
		position: 'relative',

		'&:hover': {
			backgroundColor: 'var(--primary-100)',
			borderRadius: '4px',
		},
	},

	content: {
		flex: '1',
		cursor: 'pointer',
	},

	description: {
		display: '-webkit-box',
		overflow: 'hidden',
		webkitLineClamp: '2',
		WebkitBoxOrient: 'vertical',
		color: 'var(--neutral-500)',
	},
	title: {
		fontWeight: 700,
		marginBottom: '4px',
	},
	icon: {
		position: 'absolute',
		top: 5,
		left: -36,
	},
	date: {
		color: 'var(--neutral-300)',
		fontSize: '12px',
	},
};
